<template>
  <div class="d-flex-column justify-start align-start gap-18">
    <div class="d-flex-column justify-start align-start gap-5">
      <h5 class="t-white font-family-1 title-h5">
        {{ $t("new.select_date") }}
      </h5>
      <p class="regular-l font-family-2 t-grey">
        {{ $t("new.select_date_desc") }}
      </p>
    </div>
    <div class="raids_date_picker d-flex-column justify-start align-start">
      <div class="d-flex-row space-between top_area gap-10">
        <div
          class="d-flex-row chev_buttons"
          role="button"
          @click="scrollLeft('calendar_dates')"
        >
          <ChevLeft />
        </div>
        <div
          class="d-flex-row justify-start calendar_dates hide_scroll"
          ref="calendar_dates"
        >
          <div
            class="d-flex-column date_picker gap-0"
            v-for="calen in [...calendar]"
            :key="calen"
            @click="selectDate(calen)"
            :class="[
              calen.active && 'available',
              checkoutStore.getRaidDates.includes(calen.id) && 'active',
            ]"
          >
            <label class="regular-s font-family-2 t-grey">{{
              calen.day_of_week
            }}</label>
            <label class="medium-m font-family-2 t-white">{{
              calen.date
            }}</label>
          </div>
        </div>
        <div
          class="d-flex-row chev_buttons"
          role="button"
          @click="scrollRight('calendar_dates')"
        >
          <ChevRight />
        </div>
      </div>

      <div class="bottom_area">
        <div class="d-flex-column justify-start align-start">
          <WoWRaidSchedule
            v-for="group in groupLoot"
            :key="group"
            :title="group.title"
            :difficulty="group.difficulty"
            loot="Group Loot"
            :date="group.time"
            :id="group.id"
            @click="selectRaid(group, 'Group Loot')"
            :server="getSelectedServer"
          />
        </div>
        <div class="d-flex-column justify-start align-start">
          <WoWRaidSchedule
            v-for="vip in vipLoot"
            :key="vip"
            :title="vip.title"
            :difficulty="vip.difficulty"
            loot="Vip Loot"
            :date="vip.time"
            :id="vip.id"
            @click="selectRaid(vip, 'Vip Loot')"
            :server="getSelectedServer"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import WoWRaidSchedule from "../../checkout/WoWRaidSchedule.vue";
import ChevRight from "~/components/icons/ChevRight.vue";
import ChevLeft from "~/components/icons/ChevLeft.vue";
import { ref, computed, watch } from "vue";

const calendar = ref([]);
const groupLoot = ref([]);
const vipLoot = ref([]);
const calendar_dates = ref(null);

const checkoutStore = useCheckoutStore();
const { getGamePack } = useGameStore();
const { currentGameSlug } = useGameComposable();
const { getLocale } = useFunctions();

const selectedDifficulty = computed(() => {
  if (checkoutStore.getDetails?.difficultyId) {
    return getGamePack?.prices?.find(
      (price) => price.id === checkoutStore.getDetails?.difficultyId
    );
  }
  return "";
});

const groupLootOption = computed(() => {
  if (getGamePack?.pack_options) {
    return getGamePack?.pack_options?.find(
      (option) => option.const_title === "group_loot"
    );
  }
  return null;
});
const vipLootOption = computed(() => {
  if (getGamePack?.pack_options) {
    return getGamePack?.pack_options?.find(
      (option) => option.const_title === "vip_loot"
    );
  }
  return null;
});

const selectDate = (date) => {
  let dates = [date.id];
  if (checkoutStore.getRaidDates.includes(date.id)) {
    dates = [];
  }
  checkoutStore.setRaidDates(dates);
};

const selectOption = (option, disableIds) => {
  if (!checkoutStore.getPackOptions.includes(option.id)) {
    checkoutStore.removePackOption({
      optionIds: disableIds || [],
    });
    checkoutStore.setPackOptions({
      options: [...checkoutStore.getPackOptions, option.id],
    });
  }
};
const removeOption = (option) => {
  if (checkoutStore.getPackOptions.includes(option?.id)) {
    const otherOptions = checkoutStore.getPackOptions.filter(
      (packOpt) => packOpt !== option.id
    );
    checkoutStore.setPackOptions({
      options: [...otherOptions],
    });
  }
};

const selectRaid = (raid, loot) => {
  const selectedDate = calendar.value?.find((calend) =>
    checkoutStore.getRaidDates?.includes(calend.id)
  );

  if (checkoutStore.getSelectedRaid?.id === raid.id) {
    checkoutStore.setRaid(null);
    removeOption(groupLootOption.value);
    removeOption(vipLootOption.value);
  } else {
    checkoutStore.setRaid({
      title: raid.title,
      id: raid.id,
      difficulty: raid.difficulty,
      loot: loot,
      date: raid.time,
      raidDate: selectedDate.date,
    });

    if (loot === "Group Loot" && groupLootOption.value?.id) {
      selectOption(groupLootOption.value, [vipLootOption.value?.id]);
    }
    if (loot === "Vip Loot" && vipLootOption.value?.id) {
      selectOption(vipLootOption.value, [groupLootOption.value?.id]);
    }
  }
};
function scrollRight(ref) {
  const el = calendar_dates.value;
  // const cardWidth = this.getCardWidth();

  [...el.children].forEach((child) => {
    child.style.scrollSnapAlign = "start";
  });

  el.scroll({
    left: el.scrollLeft + 132,
    behavior: "smooth",
  });

  [...el.children].forEach((child) => {
    child.style.scrollSnapAlign = "";
  });
}
function scrollLeft(ref) {
  const el = calendar_dates.value;
  // const cardWidth = this.getCardWidth();
  [...el.children].forEach((child) => {
    child.style.scrollSnapAlign = "start";
  });

  el.scroll({
    left: el.scrollLeft - 132,
    behavior: "smooth",
  });

  [...el.children].forEach((child) => {
    child.style.scrollSnapAlign = "";
  });
}
const fetchData = async () => {
  try {
    const { data: response } = await useApiPost(
      "/api/get-mmo-game-raids-schedule",
      {
        method: "post",

        fetchKey: `get-mmo-game-raids-schedule`,
        body: {
          locale: getLocale(),
          game: currentGameSlug,
          difficulty: selectedDifficulty.value?.title || "Normal",
          server: checkoutStore.getSelectedServer?.value || 1,
          day: checkoutStore.getRaidDates.length
            ? checkoutStore.getRaidDates[0]
            : 0,
        },
      }
    );
    // console.log(response);
    calendar.value = response?.calendar || [];
    if (checkoutStore.getRaidDates.length <= 0) {
      selectDate(calendar.value[0]);
    }
    groupLoot.value = response?.group_loot || [];
    vipLoot.value = response?.vip_loot || [];
  } catch (error) {
    console.log(error);
  }
};

fetchData();

watch(selectedDifficulty, (newVal) => {
  fetchData();
});

watch(
  () => checkoutStore.getSelectedServer,
  (newVal) => {
    fetchData();
  },
  {
    deep: true,
  }
);

watch(
  () => checkoutStore.getRaidDates,
  (newVal) => {
    if (checkoutStore.getSelectedRaid?.id) {
      checkoutStore.setRaid(null);
      checkoutStore.removeAllPackOptions(null);
    }
  },
  {
    deep: true,
  }
);

watch(
  () => checkoutStore.getSelectedServer?.value,
  (newVal) => {
    if (checkoutStore.getSelectedRaid?.id) {
      checkoutStore.setRaid(null);
      checkoutStore.removeAllPackOptions(null);
    }
  },
  {
    deep: true,
  }
);
</script>
